module.exports = __webpack_public_path__ + "img/173-canary islands.25731acf.svg";